module.exports = __webpack_public_path__ + "img/3.43a20b4b.jpg";